import { GeoJSON, useMap } from "react-leaflet";
import { exportDataFr, exportDataBe } from "./exportData";
import { useRef, useState, useEffect } from "react";
import L, { get, latLngBounds, openOn, zoomOntoMarker, latLng } from "leaflet";

export const GeoData = () => {
  const geoRef = useRef(null);
  const data = exportDataFr();
  const [currentProduct, setCurrentProduct] = useState(null);

  const setColor = (feature) => {
    const produit = feature.properties?.produit;
    if (produit === "SUD-EST") {
      return {
        color: "#fff",
        fillColor: "#ffa151",
        fillOpacity: 0.8,
        weight: 1,
      };
    } else if (produit === "SUD-OUEST") {
      return {
        color: "#fff",
        fillColor: "#2893bb",
        fillOpacity: 0.8,
        weight: 1,
      };
    } else if (produit === "ATLANTIQUE") {
      return {
        color: "#fff",
        fillColor: "#74ad85",
        fillOpacity: 0.8,
        weight: 1,
      };
    } else if (produit === "NORD-EST") {
      return {
        color: "#fff",
        fillColor: "#52d3f7",
        fillOpacity: 0.8,
        weight: 1,
      };
    } else if (produit === "IDF-NORMANDIE") {
      return {
        color: "#fff",
        fillColor: "#ee8369",
        fillOpacity: 0.8,
        weight: 1,
      };
    } else {
      return { color: "#fff", fillColor: "yellow" };
    }
  };

  useEffect(() => {
    if (currentProduct) {
      for (const [key, value] of Object.entries(geoRef.current["_layers"])) {
        if (value.feature.properties.produit === currentProduct) {
          value["_path"].classList.add("selected");
          value["_path"].classList.remove("unselected");
        } else {
          value["_path"].classList.add("unselected");
          value["_path"].classList.remove("selected");
        }
      }
    } else {
      for (const [key, value] of Object.entries(geoRef.current["_layers"])) {
        value["_path"].classList.remove("unselected");
        value["_path"].classList.remove("selected");
      }
    }
  }, [currentProduct]);

  const handleGeoClick = (layer) => {
    const layersArray = [];
    const clickedProduit = layer.layer.feature.properties.produit;

    for (const [key, value] of Object.entries(geoRef.current["_layers"])) {
      if (currentProduct === clickedProduit) {
        setCurrentProduct(null);
      } else {
        setCurrentProduct(clickedProduit);
      }
      // if (value.feature.properties.produit === clickedProduit) {
      //   console.log(value);
      //   // value.setStyle({ fillColor: "red", transform: "scale(2)" });
      //   value["_path"].classList.add("selected");
      //   value["_path"].classList.remove("unselected");
      // } else {
      //   value["_path"].classList.add("unselected");
      //   value["_path"].classList.remove("selected");
      // }
    }
  };

  const handleFeatureClick = (e) => {
    const layer = e.target;
    layer.setStyle({ fillColor: "red", transform: "scale(2)" });
  };

  return (
    <GeoJSON
      data={data}
      style={setColor}
      eventHandlers={{ click: handleGeoClick }}
      ref={geoRef}
      // onEachFeature={addClass}
    />
  );
};

export default GeoData;
